export const areasObject = {
  '011000': {
    name: '北海道／稚内',
    enName: 'Soya',
    officeName: '稚内地方気象台',
    parent: '010100',
    children: ['011000'],
  },
  '012000': {
    name: '北海道／旭川',
    enName: 'Kamikawa Rumoi',
    officeName: '旭川地方気象台',
    parent: '010100',
    children: ['012010', '012020'],
  },
  '013000': {
    name: '北海道／網走',
    enName: 'Abashiri Kitami Mombetsu',
    officeName: '網走地方気象台',
    parent: '010100',
    children: ['013010', '013020', '013030'],
  },
  '014100': {
    name: '北海道／釧路',
    enName: 'Kushiro Nemuro',
    officeName: '釧路地方気象台',
    parent: '010100',
    children: ['014010', '014020'],
  },
  '015000': {
    name: '北海道／室蘭',
    enName: 'Iburi Hidaka',
    officeName: '室蘭地方気象台',
    parent: '010100',
    children: ['015010', '015020'],
  },
  '016000': {
    name: '北海道／札幌',
    enName: 'Ishikari Sorachi Shiribeshi',
    officeName: '札幌管区気象台',
    parent: '010100',
    children: ['016010', '016020', '016030'],
  },
  '017000': {
    name: '函館',
    enName: 'Oshima Hiyama',
    officeName: '函館地方気象台',
    parent: '010100',
    children: ['017010', '017020'],
  },
  '020000': {
    name: '青森県',
    enName: 'Aomori',
    officeName: '青森地方気象台',
    parent: '010200',
    children: ['020010', '020020', '020030'],
  },
  '030000': {
    name: '岩手県',
    enName: 'Iwate',
    officeName: '盛岡地方気象台',
    parent: '010200',
    children: ['030010', '030020', '030030'],
  },
  '040000': {
    name: '宮城県',
    enName: 'Miyagi',
    officeName: '仙台管区気象台',
    parent: '010200',
    children: ['040010', '040020'],
  },
  '050000': {
    name: '秋田県',
    enName: 'Akita',
    officeName: '秋田地方気象台',
    parent: '010200',
    children: ['050010', '050020'],
  },
  '060000': {
    name: '山形県',
    enName: 'Yamagata',
    officeName: '山形地方気象台',
    parent: '010200',
    children: ['060010', '060020', '060030', '060040'],
  },
  '070000': {
    name: '福島県',
    enName: 'Fukushima',
    officeName: '福島地方気象台',
    parent: '010200',
    children: ['070010', '070020', '070030'],
  },
  '080000': {
    name: '茨城県',
    enName: 'Ibaraki',
    officeName: '水戸地方気象台',
    parent: '010300',
    children: ['080010', '080020'],
  },
  '090000': {
    name: '栃木県',
    enName: 'Tochigi',
    officeName: '宇都宮地方気象台',
    parent: '010300',
    children: ['090010', '090020'],
  },
  '100000': {
    name: '群馬県',
    enName: 'Gunma',
    officeName: '前橋地方気象台',
    parent: '010300',
    children: ['100010', '100020'],
  },
  '110000': {
    name: '埼玉県',
    enName: 'Saitama',
    officeName: '熊谷地方気象台',
    parent: '010300',
    children: ['110010', '110020', '110030'],
  },
  '120000': {
    name: '千葉県',
    enName: 'Chiba',
    officeName: '銚子地方気象台',
    parent: '010300',
    children: ['120010', '120020', '120030'],
  },
  '130000': {
    name: '東京都',
    enName: 'Tokyo',
    officeName: '気象庁',
    parent: '010300',
    children: ['130010', '130020', '130030', '130040'],
  },
  '140000': {
    name: '神奈川県',
    enName: 'Kanagawa',
    officeName: '横浜地方気象台',
    parent: '010300',
    children: ['140010', '140020'],
  },
  '150000': {
    name: '新潟県',
    enName: 'Niigata',
    officeName: '新潟地方気象台',
    parent: '010500',
    children: ['150010', '150020', '150030', '150040'],
  },
  '160000': {
    name: '富山県',
    enName: 'Toyama',
    officeName: '富山地方気象台',
    parent: '010500',
    children: ['160010', '160020'],
  },
  '170000': {
    name: '石川県',
    enName: 'Ishikawa',
    officeName: '金沢地方気象台',
    parent: '010500',
    children: ['170010', '170020'],
  },
  '180000': {
    name: '福井県',
    enName: 'Fukui',
    officeName: '福井地方気象台',
    parent: '010500',
    children: ['180010', '180020'],
  },
  '190000': {
    name: '山梨県',
    enName: 'Yamanashi',
    officeName: '甲府地方気象台',
    parent: '010300',
    children: ['190010', '190020'],
  },
  '200000': {
    name: '長野県',
    enName: 'Nagano',
    officeName: '長野地方気象台',
    parent: '010300',
    children: ['200010', '200020', '200030'],
  },
  '210000': {
    name: '岐阜県',
    enName: 'Gifu',
    officeName: '岐阜地方気象台',
    parent: '010400',
    children: ['210010', '210020'],
  },
  '220000': {
    name: '静岡県',
    enName: 'Shizuoka',
    officeName: '静岡地方気象台',
    parent: '010400',
    children: ['220010', '220020', '220030', '220040'],
  },
  '230000': {
    name: '愛知県',
    enName: 'Aichi',
    officeName: '名古屋地方気象台',
    parent: '010400',
    children: ['230010', '230020'],
  },
  '240000': {
    name: '三重県',
    enName: 'Mie',
    officeName: '津地方気象台',
    parent: '010400',
    children: ['240010', '240020'],
  },
  '250000': {
    name: '滋賀県',
    enName: 'Shiga',
    officeName: '彦根地方気象台',
    parent: '010600',
    children: ['250010', '250020'],
  },
  '260000': {
    name: '京都府',
    enName: 'Kyoto',
    officeName: '京都地方気象台',
    parent: '010600',
    children: ['260010', '260020'],
  },
  '270000': {
    name: '大阪府',
    enName: 'Osaka',
    officeName: '大阪管区気象台',
    parent: '010600',
    children: ['270000'],
  },
  '280000': {
    name: '兵庫県',
    enName: 'Hyogo',
    officeName: '神戸地方気象台',
    parent: '010600',
    children: ['280010', '280020'],
  },
  '290000': {
    name: '奈良県',
    enName: 'Nara',
    officeName: '奈良地方気象台',
    parent: '010600',
    children: ['290010', '290020'],
  },
  '300000': {
    name: '和歌山県',
    enName: 'Wakayama',
    officeName: '和歌山地方気象台',
    parent: '010600',
    children: ['300010', '300020'],
  },
  '310000': {
    name: '鳥取県',
    enName: 'Tottori',
    officeName: '鳥取地方気象台',
    parent: '010700',
    children: ['310010', '310020'],
  },
  '320000': {
    name: '島根県',
    enName: 'Shimane',
    officeName: '松江地方気象台',
    parent: '010700',
    children: ['320010', '320020', '320030'],
  },
  '330000': {
    name: '岡山県',
    enName: 'Okayama',
    officeName: '岡山地方気象台',
    parent: '010700',
    children: ['330010', '330020'],
  },
  '340000': {
    name: '広島県',
    enName: 'Hiroshima',
    officeName: '広島地方気象台',
    parent: '010700',
    children: ['340010', '340020'],
  },
  '350000': {
    name: '山口県',
    enName: 'Yamaguchi',
    officeName: '下関地方気象台',
    parent: '010900',
    children: ['350010', '350020', '350030', '350040'],
  },
  '360000': {
    name: '徳島県',
    enName: 'Tokushima',
    officeName: '徳島地方気象台',
    parent: '010800',
    children: ['360010', '360020'],
  },
  '370000': {
    name: '香川県',
    enName: 'Kagawa',
    officeName: '高松地方気象台',
    parent: '010800',
    children: ['370000'],
  },
  '380000': {
    name: '愛媛県',
    enName: 'Ehime',
    officeName: '松山地方気象台',
    parent: '010800',
    children: ['380010', '380020', '380030'],
  },
  '390000': {
    name: '高知県',
    enName: 'Kochi',
    officeName: '高知地方気象台',
    parent: '010800',
    children: ['390010', '390020', '390030'],
  },
  '400000': {
    name: '福岡県',
    enName: 'Fukuoka',
    officeName: '福岡管区気象台',
    parent: '010900',
    children: ['400010', '400020', '400030', '400040'],
  },
  '410000': {
    name: '佐賀県',
    enName: 'Saga',
    officeName: '佐賀地方気象台',
    parent: '010900',
    children: ['410010', '410020'],
  },
  '420000': {
    name: '長崎県',
    enName: 'Nagasaki',
    officeName: '長崎地方気象台',
    parent: '010900',
    children: ['420010', '420020', '420030', '420040'],
  },
  '430000': {
    name: '熊本県',
    enName: 'Kumamoto',
    officeName: '熊本地方気象台',
    parent: '010900',
    children: ['430010', '430020', '430030', '430040'],
  },
  '440000': {
    name: '大分県',
    enName: 'Oita',
    officeName: '大分地方気象台',
    parent: '010900',
    children: ['440010', '440020', '440030', '440040'],
  },
  '450000': {
    name: '宮崎県',
    enName: 'Miyazaki',
    officeName: '宮崎地方気象台',
    parent: '011000',
    children: ['450010', '450020', '450030', '450040'],
  },
  '460100': {
    name: '鹿児島県',
    enName: 'Kagoshima (Excluding Amami)',
    officeName: '鹿児島地方気象台',
    parent: '011000',
    children: ['460010', '460020', '460030'],
  },
  '471000': {
    name: '沖縄本島地方',
    enName: 'Okinawa Main Island',
    officeName: '沖縄気象台',
    parent: '011100',
    children: ['471010', '471020', '471030'],
  },
  '472000': {
    name: '沖縄/大東島地方',
    enName: 'Daitojima',
    officeName: '南大東島地方気象台',
    parent: '011100',
    children: ['472000'],
  },
  '473000': {
    name: '沖縄/宮古島地方',
    enName: 'Miyakojima',
    officeName: '宮古島地方気象台',
    parent: '011100',
    children: ['473000'],
  },
  '474000': {
    name: '沖縄/八重山地方',
    enName: 'Yaeyama',
    officeName: '石垣島地方気象台',
    parent: '011100',
    children: ['474010', '474020'],
  },
};
